<script setup>
import { watch, ref, onMounted } from 'vue';
import { storeToRefs } from "pinia";
import RoleContent from './role-content.vue';
import { useFVStore } from '../../stores/formvibes';
import { Loading } from '@element-plus/icons-vue';

const store = useFVStore();

const {isSaving} = storeToRefs(store);
const capabilities = ref({});
const userRoles = ref(window.fv_role_manager_data.roles)
const roles = ref(window.fv_role_manager_data.roles);
const activeNames = ref([]);

onMounted(() => {
     roles.value = Object.fromEntries( Object.entries(roles.value).filter(([key, value]) => key !== 'administrator') );
    
});
const updateCap = (cap) => {
    capabilities.value = cap;
}
const saveRoles = () => {
    store.saveRoles(capabilities.value);
}

</script>
<template>
    <div>
        <el-collapse v-model="activeNames">
            <el-collapse-item v-for="(role,key,index) in roles" :title="role.name" :key="index">
                    <template #title>
                        <h4>{{role.name}}</h4>
                    </template>
                    <RoleContent :roleKey="key" :role="roles[key]" :setCap="updateCap" :caps="capabilities"/>
            </el-collapse-item>
        </el-collapse>
        <el-button @click="saveRoles" type="primary" class="fv-save-button">
            <el-icon v-if="isSaving"><Loading /></el-icon>
            Save Settings
        </el-button>
    </div>
</template>